import {Injectable} from '@angular/core';
import Quill from 'quill';
import {AppInjector} from '../../../../../../../../../app-injector.helper';
import {ImageService} from '../../../../../../../../../shared/services/advtech/image';
import {ImagePreviewService} from '../../../../../../../services/image-preview';
import {ImageShortcodeActionSheet} from '../../../../../../action-sheet/image-shortcode-action-sheet';
import {BlockShortcodeBlot} from '../block';

@Injectable()
export class ImageShortcodeBlot extends BlockShortcodeBlot {

  static blotName: string = 'imageShortcode';

  static tagName: string = 'DIV';

  /** @inheritdoc */
  static create(domNode: HTMLElement) {
    if (this.isImageShortcode(domNode)) {
      const data = domNode.dataset;
      const img = document.createElement('IMG') as HTMLImageElement;
      const imageService = AppInjector.get(ImageService);
      img.src = imageService.buildImageUrl(data.uuid);
      img.setAttribute('data-shortcode', 'image');
      return img;
    }
    return super.create(domNode);
  }

  /** @inheritdoc */
  static value(domNode) {
    if (this.isImageShortcode(domNode)) {
      return domNode;
    }
    super.value(domNode);
  }

  /**
   * Checks for the presence of the data-shortcode=image attribute
   * @param {HTMLElement} domNode
   * @returns {boolean}
   */
  static isImageShortcode(domNode: HTMLElement): boolean {
    return domNode.dataset && domNode.dataset.shortcode === 'image';
  }

  /**
   * Transforms an Image object to the required DOMStringMap
   * @param {{}} image
   * @returns {DOMStringMap}
   */
  static imageToDataset(image): DOMStringMap {
    return {
      float: 'left',
      imageAltText: image.alt,
      imageCaption: image.caption,
      imageCredit: image.credits,
      imageDateCreated: new Date(image.dateCreated.date).format('Y/m/d'),
      imageDoNotCrop: image.doNotCrop || 'false',
      imageDoNotResize: image.doNotResize || 'false',
      imageFilename: image.filename,
      imageHeight: image.height,
      imageWatermark: image.watermark || 'false',
      imageWidth: image.width,
      lightbox: 'false',
      shortcode: 'image',
      size: 'medium',
      uuid: image.id,
    };
  }

  actionSheet: ImageShortcodeActionSheet;
  previewService: ImagePreviewService;
  imageService: ImageService;
  imageData: any;

  constructor(public domNode: HTMLElement, value?: HTMLElement) {
    super(domNode, value);
    if (ImageShortcodeBlot.isImageShortcode(domNode)) {
      this.data = value.dataset;
      this.modelTag = value;
      this.actionSheet = AppInjector.get(ImageShortcodeActionSheet);
      this.previewService = AppInjector.get(ImagePreviewService);
      this.imageService = AppInjector.get(ImageService);
      this.imageService.getImageData(this.data.uuid, true).subscribe((image) => {
        this.imageData = image;
      });
      this.domNode = domNode;
      domNode.addEventListener('click', () => {
        if (!domNode.closest('.ql-editor[contenteditable="false"]')) {
          const actionSheet = this.actionSheet.present({});
          actionSheet.onDidDismiss((action) => {
            switch (action) {
              case 'remove':
                this.hRemove();
                break;
              case 'preview':
                this.hPreview();
                break;
            }
          });

          // this.actionSheet.onPreview.observers.length === 0 && this.actionSheet.onPreview.subscribe(() => {
          //   this.hPreview();
          // });
          // TODO: implement in PRMOBILE-22
          // this.actionSheet.onEdit.subscribe(this.hEdit);
        }
      });
    }
  }

  /**
   * Removes the image from the dom
   * @returns {void}
   */
  hRemove(): void {
    const domNode = Quill.find(this.domNode);
    domNode.remove();
  }

  hPreview(): void {
    this.previewService.items = [{image: this.imageData, normalUrl: this.imageData.path}];
    this.previewService.showPreview(0);
  }

  /**
   * Gets the model tag for the shortcode
   * @param {DOMStringMap} data
   * @returns {HTMLElement}
   */
  getModelTag(data?: DOMStringMap): HTMLElement {
    const div = document.createElement('DIV');
    this.setDataAttributes(div, data);
    return div;
  }
}



// WEBPACK FOOTER //
// ./src/app/content/shared/components/inputs/body/quill/blots/shortcode/image/image.shortcode.blot.ts